<template>
  <div>
    <!--/*  タイムライン  */-->
    <!--/*
      todo:ログイン後の画面を変更する 
      <template v-if="$root.account.isLogin">
    */-->
    <template v-if="false">
      <h4 class="mainpage_title" style="margin-top: 1.5rem; margin-bottom: 1.5rem; font-weight: 700">タイムライン</h4>
      <div style="display: flex;flex-wrap: wrap;">
        <div v-if="!mainPageDto || !mainPageDto.followedList || !mainPageDto.followedList.content">
          誰かをフォローしよう！
        </div>
        <PublicPageList
          v-else
          :list="mainPageDto.followedList.content"
        ></PublicPageList>
      </div>
      <!--/*  続き読むボタン  */-->
      <div style="display: flex; margin-top: 1rem; justify-content: center;">
        <router-link to="/projects" class="btn projectListButton btn-sm" style="margin-right: 0.5rem;">
          記事一覧へ
        </router-link>
      </div>
    </template>

    <!--/*
    todo:画面変更しよう
    <h4 class="mainpage_title" style="margin-top: 1.5rem; margin-bottom: 1.5rem; font-weight: 700">新着</h4>
    */-->
    <div style="justify-content: center;display: flex;flex-wrap: wrap;">
      <Loading ref="loading" :enableOnScrollEnd="true" @onscrollend="onScrollEnd">
        <PublicPageList 
          v-if="mainPageDto && mainPageDto.updatedProjectList && mainPageDto.updatedProjectList.content"
          :list="mainPageDto.updatedProjectList.content" />
      </Loading>
    </div>
    <!--/*
    <div style="display: flex; margin-top: 1rem; justify-content: center">
      <router-link to="/projects" class="btn projectListButton btn-sm" style="margin-right: 0.5rem">
        記事一覧へ
      </router-link>
    </div>
    */-->

    <!--/*
    <h4 class="mainpage_title" style="margin-top: 1.5rem; margin-bottom: 1.5rem; font-weight: 700">人気</h4>
    <div style="display: flex;flex-wrap: wrap;">
      <PublicPageList
        v-if="mainPageDto && mainPageDto.popularList && mainPageDto.popularList.content" 
        :list="mainPageDto.popularList.content" />
    </div>
    <div style="display: flex; margin-top: 1rem; justify-content: center">
      <router-link to="/projects" class="btn projectListButton btn-sm" style="margin-right: 0.5rem">
        記事一覧へ
      </router-link>
    </div>
    */-->
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import { Ref } from "vue-property-decorator";
import PublicPageList from "@/component/publicPageList/PublicPageList.vue";
import Loading from "@/component/Loading.vue"

@Options({ components: { PublicPageList,Loading } })
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly loading = null as any as Loading;

  mainPageDto = {
    followedList: { content: [] },
    updatedProjectList: { content: [] },
    popularList: { content: [] },
  };
  pageable = {
    size: 10,
    page: 0,
  }

  getProjectList() {
    this.loading?.start()
    this.$root.restAccess.getUpdatedPublicPageList(this.pageable).then((res: Response) => {
      if (res.status >= 400) {
      this.loading?.finish()
        return;
      }

      res.json().then((data:any) => {
        this.loading?.finish()

        this.mainPageDto.updatedProjectList.content.push(...data.content as never[]);
    
        this.pageable.page += 1;

        // 最終ページだと終わり
        if (data.content.length === this.pageable.size) {
          this.loading.enableNextScrollEnd()
        }
        // console.log(data);
      });
    });
  }
  onScrollEnd(){
    this.getProjectList()
  }

  mounted() {
    this.getProjectList();
  }
}
</script>


<style lang="scss" scoped>
.projectListButton {
  background-color: white;
}
</style>
